<lib-ph-bhp-report-sop [userData]="config.userData" (childData)=onChildData($event)></lib-ph-bhp-report-sop>